import { Popover } from '@abyss/web/ui/Popover';
import find from 'lodash/find';
import { useEffect, useState } from 'react';

import { adobeModalTrackEvent } from '../../../common/AdobeTagging/adobeModalTrackEvent';
import { useIsNiceMember } from '../../../hooks/useIsNiceMember';
import { useLagoon } from '../../../hooks/useLagoon';
import { returnSuppressFlag } from '../../../utils/featureSuppress';
import { useIsEligibleForStandaloneDental } from '../../../utils/user.utils';
import { adobeLinkTrackEvent } from '../../AdobeTagging/adobeLinkTrackEvent';
import { ConstantsLagoon } from '../../ConstantsLagoon';
import { getFeatureFlag } from '../../Utils';
import {
  StyledPopoverWrapper,
  StyledSmartChoiceChipContainer,
  StyledSmartChoiceChipText,
  StyledSmartChoiceWrapper,
} from './SmartChoiceInfoChip.styled';

export const SmartChoiceInfoChip = ({
  chipLabel = '',
  popoverTitle = '',
  popoverContent = '',
  wrapperStyle = {},
}) => {
  const isNiceMember = useIsNiceMember();
  const lagoonData = useLagoon('ui-messaging')();
  const featureFlags: [{ key: string; active: boolean }] =
    useLagoon('feature-flags')();
  const smartChoiceNotAvailable = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE.SMART_CHOICE_NOT_AVAILABLE,
  });
  const smartChoiceAvailability = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE.SMART_CHOICE_AVAILABILITY,
  });
  const enableNonSmartChoiceDisclaimer = getFeatureFlag(
    featureFlags,
    ConstantsLagoon?.FEATURE_FLAGS.ENABLE_NON_SMART_CHOICE_DISCLAIMER
  );
  const enablePSXProviderRecommendations = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_PSX_PROVIDER_RECOMMENDATIONS
  );
  const isSmartChoiceSuppressed = returnSuppressFlag(
    ConstantsLagoon.FEATURE_SUPPRESSION_FLAGS.SMART_CHOICE
  );
  const enableAdobeAnalytic = getFeatureFlag(
    featureFlags,
    ConstantsLagoon?.FEATURE_FLAGS.ENABLE_NEW_UX_SMART_CHOICE_ANALYTICS
  );
  const isEligibleForStandaloneDental = useIsEligibleForStandaloneDental();
  const renderSCChip =
    enableNonSmartChoiceDisclaimer &&
    enablePSXProviderRecommendations &&
    !isSmartChoiceSuppressed &&
    !isEligibleForStandaloneDental &&
    !isNiceMember;

  const [openInfoPopover, setOpenInfoPopover] = useState(false);
  const chipTxt = chipLabel ? chipLabel : smartChoiceNotAvailable?.message;
  const popoverTxt = popoverTitle
    ? popoverTitle
    : smartChoiceAvailability?.message;

  useEffect(() => {
    if (!openInfoPopover || !popoverTxt || !enableAdobeAnalytic) return;
    adobeModalTrackEvent(popoverTxt);
  }, [openInfoPopover]);

  const hanldeInfoClick = () => {
    if (openInfoPopover) return;
    if (!enableAdobeAnalytic) return;
    adobeLinkTrackEvent({
      name: `${chipTxt} icon`,
      location: chipTxt,
    });
  };

  return (
    renderSCChip && (
      <StyledSmartChoiceWrapper
        css={wrapperStyle}
        data-testid="smart-choice-wrapper"
      >
        <StyledSmartChoiceChipContainer data-testid="smart-choice-chip-container">
          <StyledSmartChoiceChipText data-testid="smart-choice-chip-text">
            {chipTxt}
          </StyledSmartChoiceChipText>
          <StyledPopoverWrapper data-testid="smart-choice-popover-wrapper">
            <Popover
              content={popoverContent}
              data-testid="smart-choice-popover"
              onClick={hanldeInfoClick}
              onOpenChange={() => {
                setOpenInfoPopover(!openInfoPopover);
              }}
              open={openInfoPopover}
              title={popoverTxt}
            />
          </StyledPopoverWrapper>
        </StyledSmartChoiceChipContainer>
      </StyledSmartChoiceWrapper>
    )
  );
};
